import React, { ChangeEvent } from 'react';
import {
  Grid,
  MenuItem,
  Tooltip,
  TextField,
  SelectChangeEvent,
} from '@mui/material';
import { SyncLock, CloudUpload, AddCircle } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import Autocomplete from '@mui/material/Autocomplete';
import CustomButton, {
  CustomSelect,
} from '../../../../Common/Components/Controls/InputControls';
import HeaderToolbar from '../../../../Common/Components/HeaderToolbar';
import SearchBar from '../../../../Common/Components/Controls/SearchBar';

interface FilterToolbarProps {
  Type: string;
  handleChange: (event: SelectChangeEvent<string>) => void;
  farmtopologies: { FarmType: string }[];
  farmTags: string[];
  selectedFarmTags: string[];
  onSelectedFarmTag: (tags: string[]) => void;
  updateSSlBindings: () => void;
  onFilterRequest: (event: ChangeEvent<HTMLInputElement>) => void;
}

const FarmHeaderToolbar: React.FC<FilterToolbarProps> = ({
  Type,
  handleChange,
  farmtopologies,
  farmTags,
  selectedFarmTags,
  onSelectedFarmTag,
  updateSSlBindings,
  onFilterRequest,
}) => {
  return (
    <HeaderToolbar
      leftContent={
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <CustomSelect
              labelId="Subscription"
              value={Type}
              onChange={handleChange}
              name="Subscription"
            >
              {farmtopologies.map((topology) => (
                <MenuItem key={topology.FarmType} value={topology.FarmType}>
                  {topology.FarmType}
                </MenuItem>
              ))}
            </CustomSelect>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              multiple
              value={selectedFarmTags}
              options={farmTags}
              onChange={(event, newValue) => onSelectedFarmTag(newValue)}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Tags"
                  size="small"
                  fullWidth
                  sx={{ minHeight: 40 }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <SearchBar onChange={onFilterRequest} width="100%" />
          </Grid>
        </Grid>
      }
      rightContent={
        <Grid item xs={12} md={5}>
          <Grid
            container
            spacing={1}
            alignItems="center"
            justifyContent={{ xs: 'center', md: 'flex-end' }}
            flexWrap="wrap"
          >
            {[
              {
                title: 'Update SSL Bindings',
                icon: <SyncLock />,
                onClick: updateSSlBindings,
                label: 'Sync SSL',
              },
              {
                title: 'Deployment Center',
                icon: <CloudUpload />,
                component: Link,
                to: `/farm/${Type}/deploymentcenter`,
                label: 'Deployment',
              },
              {
                title: 'Create Farm',
                icon: <AddCircle />,
                component: Link,
                to: '/farm/new',
                label: 'Create Farm',
              },
            ].map((button, index) => (
              <Grid key={index} item xs={12} sm="auto">
                <Tooltip title={button.label}>
                  <CustomButton
                    startIcon={button.icon}
                    {...(button.component
                      ? { component: button.component, to: button.to }
                      : { onClick: button.onClick })}
                    label={button.label}
                  />
                </Tooltip>
              </Grid>
            ))}
          </Grid>
        </Grid>
      }
    />
  );
};

export default FarmHeaderToolbar;
